import { render, staticRenderFns } from "./editGoodsLog.vue?vue&type=template&id=dc9ffe1e&scoped=true"
import script from "./editGoodsLog.vue?vue&type=script&lang=js"
export * from "./editGoodsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9ffe1e",
  null
  
)

export default component.exports